import { HttpModelConverter } from "src/app/modules/core/converter/httpModel.converter";
import { MedicalDeviceSummaryModel } from "../medicalDeviceSummary.model";
import { Injectable } from "@angular/core";
import { PermissionsConverter } from "src/app/modules/common/converter/permissions.converter";
import {
    DeviceDefinitionSummaryConverter
} from "../../../../definition/api/entity/converter/deviceDefinitionSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class MedicalDeviceSummaryConverter extends HttpModelConverter<MedicalDeviceSummaryModel> {
    constructor(private permissionConverter: PermissionsConverter,
                private definitionSummaryConverter: DeviceDefinitionSummaryConverter) {
        super();
    }

    protected createInstance(): MedicalDeviceSummaryModel {
        return new MedicalDeviceSummaryModel();
    }

    protected enrichObject(result: MedicalDeviceSummaryModel, src: MedicalDeviceSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
        result.definition = this.definitionSummaryConverter.convert(src.definition);
    }
}

